import React from 'react';
import Shimmer from '../Shimmer/Shimmer';
import {TableLoaderCont} from './Table.styles';

const TableLoader = () => {
  return (
    <TableLoaderCont>
      <Shimmer width={'100%'} height="40px" />
      <div className="body">
        <Shimmer width={'100%'} height="40px" />
      </div>
    </TableLoaderCont>
  );
};

export default TableLoader;
